/* eslint-disable */

import React from 'react'
import { Card } from '../ui/card'

const StatCard = ({
  title,
  amount,
  amountColor,
  description,
  subtext,
  icon: Icon,
  iconColor,
  iconTextColor,
}) => {
  return (
    <Card className='space-y-3 rounded-lg border-black-100 bg-white p-4 shadow-[0_8px_24px_rgba(4,3,19,0.05)]'>
      <div className='flex items-start justify-between gap-3'>
        <div className='min-w-0'>
          <h3 className='text-sm font-semibold leading-5 text-black-500'>{title}</h3>
          <h2 className={`text-2xl ${amountColor} font-bold leading-8`}>{amount}</h2>
        </div>

        <div
          className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full p-2 ${iconColor}`}
        >
          <Icon className={`h-5 w-5 ${iconTextColor}`} />
        </div>
      </div>

      <div>
        <p className='text-xs font-medium leading-4 text-black-400'>{description}</p>
        <p className='text-xs leading-4 text-muted-foreground'>{subtext}</p>
      </div>
    </Card>
  )
}

export default StatCard
